var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.42534,
    height: 50.91776,
    viewBox: "0 0 58.42534 50.91776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4aa41;}.cls-2{fill:#ea5a47;}.cls-3{fill:#3f3f3f;}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.86298,4.04968l-4.5,1.75L5.11298,14.29968,.61298,25.04968l2,5.25c1.2554,3.7911,3.5231,7.1832,7.25,10l2.5-3.3333s3.8218,7.7098,10.7384,8.9598c0,0,10.2616,1.936,15.5949-.8765,3.4203-1.8037,4.4167-4.4167,4.4167-4.4167l3.4167-3.4167,1.5833,2.3333,2.0833-.0833,5.4167-7.25,1.75-5.4166-.1667-4.5-2.3333-5.5-4.8333-7.4167s-2.6667-4.9167-8.1667-3.9167c0,0-6.5-4.8333-11.8333-4.0833s-4.5834-1.25-13.1667,2.6667Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.36298 36.71628 26.27967 39.13298 23.77968 39.13298 23.69627 42.96628 24.44627 46.46628 25.52967 48.38298 28.36298 49.88298 32.94628 49.29968 34.52967 47.54968 35.52967 43.29968 35.27967 39.29968 33.27967 39.54968 29.36298 36.71628"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "25.86298 26.38298 24.27968 30.13298 26.44628 31.38298 27.69628 31.88298 32.02967 32.04968 34.94628 29.79968 33.19628 26.54968 25.86298 26.38298"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.86887,19.57298s-1.8051,1.2424-2.7484,.6679c-.9434-.5745-1.2424-1.8051-.6679-2.7484s1.805-1.2424,2.7484-.6679,.6679,2.7484,.6679,2.7484Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.47187,26.47018h6.1457c.4011,0,.7634,.2397,.9203,.6089l1.1579,2.7245-2.1792,1.1456c-.6156,.3236-1.3654-.0645-1.4567-.754"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.12358,30.22718c-.1132,.6268-.7757,.9895-1.3647,.7471l-2.3132-.952,1.0899-2.9035c.1465-.3901,.5195-.6486,.9362-.6486"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.79937,39.49098s-.7187,8.7934,3.0072,9.9375c2.6459,.8125,5.1497,.5324,6.0625-.25,.875-.75,2.6323-4.4741,1.8267-9.6875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.62657,19.57298s1.805,1.2424,2.7484,.6679,1.2424-1.8051,.6679-2.7484c-.5745-.9434-1.805-1.2424-2.7484-.6679s-.6679,2.7484-.6679,2.7484Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.98748,32.30348c-.475,3.6024,2.2343,5.7505,4.2847,6.8414,1.1968,.6367,2.6508,.5182,3.7176-.3181l2.581-2.0233,2.581,2.0233c1.0669,.8363,2.5209,.9548,3.7176,.3181,2.0504-1.0909,4.7597-3.239,4.2847-6.8414"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.31387,17.82138c-2.3166,5.1597-.5084,13.0249,.119,15.3759,.122,.4571,.0755,.9355-.1271,1.3631l-1.9874,4.1937c-.623,1.3146-2.3934,1.5533-3.331,.4409C4.79527,35.40787-.57103,27.80508,1.43877,22.50897,8.50127,3.89858,17.30647,4.36607,17.30647,4.36607c2.8453-1.9336,13.1042-6.9375,24.8125,.875,0,0,8.6323-1.7175,14.9375,16.9375,1.8036,5.3362-3.4297,12.8668-6.5506,16.6442-.9312,1.127-2.7162,.8939-3.3423-.4272l-1.9741-4.1656c-.2026-.4275-.2491-.906-.1271-1.3631,.6275-2.3509,2.4356-10.2161,.119-15.3759"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.99388,35.92698s-3.0781,6.7216-7.8049,8.2712"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.79998,36.43318s3.0781,6.0823,7.8049,7.632"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29.57078,
    y1: 36.80348,
    x2: 29.57078,
    y2: 33.77348
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.0c65f23ee6d76bed9a0104b30ac98faa.svg";
export { ForwardRef as ReactComponent };